/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of party
 */
export type PartyInputType = (typeof PartyInputType)[keyof typeof PartyInputType];

export const PartyInputType = {
  Individual: 'Individual',
  Entity: 'Entity',
  Trust: 'Trust',
} as const;
